import React, { ReactElement } from 'react';
import MapFilter from './map-filter';
import SxkMap from './sxk-map';
import ChartTop from './chart-top';
import ChartActions from './chart-actions';

export default function MapPage(): ReactElement {
  return (
    <div>
      <ChartTop />
      <div id="chart-content" className="clearfix">
        <div className="c-sidebar">
          <MapFilter />
          <ChartActions />
        </div>
        <div id="chart-container" className="c-main sb-left one-sb">
          <div id="map-container">
            <SxkMap />
          </div>
          <p>
            <a href="/bojar-hamnar-och-farleder/aktuell-bojinformation">Aktuell bojinformation</a>
          </p>
        </div>
      </div>
    </div>
  );
}
